import {
  SIERRA_FAILED,
  SIERRA_INITIALIZED,
  SIERRA_LOADING,
  SIERRA_OPEN,
  SIERRA_START,
  SIERRA_UPDATED,
  ZVA_FAILED,
  ZVA_INITIALIZED,
  ZVA_LOADING,
  ZVA_OPEN,
  ZVA_START,
  ZVA_UPDATED,
} from './actionTypes'

// Zoom virtual assistant
export const startZva = () => ({
  type: ZVA_START,
})
export const zvaLoading = () => ({
  type: ZVA_LOADING,
})
export const openZva = () => ({
  type: ZVA_OPEN,
})
export const zvaInitialized = () => ({
  type: ZVA_INITIALIZED,
})
export const zvaUpdated = () => ({
  type: ZVA_UPDATED,
})
export const zvaFailed = (error: Error) => ({
  type: ZVA_FAILED,
  error,
})

// Sierra
export const startSierra = () => ({
  type: SIERRA_START,
})
export const sierraLoading = () => ({
  type: SIERRA_LOADING,
})
export const openSierra = () => ({
  type: SIERRA_OPEN,
})
export const sierraInitialized = () => ({
  type: SIERRA_INITIALIZED,
})
export const sierraUpdated = () => ({
  type: SIERRA_UPDATED,
})
export const sierraFailed = (error: Error) => ({
  type: SIERRA_FAILED,
  error,
})
